import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import BenefitHint from '../../../component/benefitTabs/BenefitHint';
import CarConnectForm from './CarConnectForm';
import { CarLinks } from './links';
import { useCarPrecondition } from './useCarPrecondition';

interface CarConnectPanelProps {
  onConnected?: () => void;
}

const CarConnectPanel: React.FC<CarConnectPanelProps> = ({ onConnected }) => {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet } = useCarPrecondition();

  return (
    <Stack alignSelf="center" alignItems="center" spacing={2} width="60%">
      <Typography variant="h1" gutterBottom>
        {t('CAR.connect.title')}
      </Typography>
      <Typography color="text.secondary" variant="body2" mb={3}>
        {t('CAR.connect.description')}
      </Typography>
      {isPreconditionMet && (
        <Alert severity="info">
          <AlertTitle> {t('CAR.connect.alert.title')}</AlertTitle>
          {t('CAR.connect.alert.description')}
        </Alert>
      )}
      <CarConnectForm onSubmit={onConnected} />
      <BenefitHint
        title={t('CAR.hint.where.title')}
        description={
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="body2">
              {t('CAR.hint.where.description')}
            </Typography>
            <Button
              variant="contained"
              size="small"
              href={CarLinks.LOGIN}
              target="_blank"
              rel="noopener noreferrer"
              color="secondary"
              sx={{ width: 'fit-content' }}
            >
              {t('CAR.hint.where.button')}
            </Button>
          </Stack>
        }
      />
      <BenefitHint
        title={t('CAR.hint.faq.title')}
        description={
          <Typography color="text.secondary" variant="body2">
            <Trans
              i18nKey="benefitsModule:CAR.hint.faq.description"
              components={{
                email: <a href={CarLinks.MAIL} />,
                site: <a href={CarLinks.SITE} target="_blank" rel="noopener noreferrer" />,
                faq: <a href={CarLinks.FAQ} target="_blank" rel="noopener noreferrer" />,
              }}
            />
          </Typography>
        }
      />
    </Stack>
  );
};

export default CarConnectPanel;
